module.exports = __webpack_public_path__ + "img/zp_nr@3x.dfa0ff7b.png";